import {loop, Effects} from 'redux-loop';

export default (isCollapsed) => {
  return loop({
    isCollapsed,
  },
    Effects.none()
  );
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/sidebar/init.js
 **/